// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const videoViewsHistoryConfig = {
    title: 'chart.twitter.video_views_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.twitter.video_views_history_name'
    },
    id: 'video_views_history',
    color: {
        value: 'purple'
    },
    tooltipTranslation: {
        token: 'chart.tiktok.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
